import { render } from "./CollapseTransition.vue?vue&type=template&id=11f69300"
import script from "./CollapseTransition.vue?vue&type=script&lang=js"
export * from "./CollapseTransition.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__